import { useCallback } from 'react'

import { Tooltip } from '@/components/primitives/Tooltip'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

import { useTexts } from './useTexts'

type Props = {
  recurrenceType: uui.domain.rm.RecurrenceTypes
  onChangeRecurrenceType: (recurrenceType: uui.domain.rm.RecurrenceTypes) => void
}

type ToggleButtonWithTooltipProps = {
  value: string
  text: string
}

const ToggleButtonWithTooltip = (props: ToggleButtonWithTooltipProps) => {
  const { value, text } = props
  return (
    <ToggleButton
      value={value}
      sx={{
        maxWidth: '100px',
        minWidth: '60px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <Tooltip placement="bottom" title={text}>
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            display: 'block',
          }}
        >
          {text}
        </span>
      </Tooltip>
    </ToggleButton>
  )
}

export function RecurrenceTypePicker(props: Props) {
  const { recurrenceType, onChangeRecurrenceType } = props
  const texts = useTexts()

  const handleOnChange = useCallback(
    (_, recurrence: uui.domain.rm.RecurrenceTypes) => {
      // If the value is null, it means the user clicked the selected button again
      if (!recurrence) return

      onChangeRecurrenceType(recurrence)
    },
    [onChangeRecurrenceType],
  )

  return (
    <ToggleButtonGroup
      size="small"
      color="primary"
      value={recurrenceType}
      exclusive
      onChange={handleOnChange}
      sx={{
        width: '100%',
        justifyContent: 'space-between',
        display: 'flex',
      }}
    >
      <ToggleButtonWithTooltip value="DATE" text={texts.oneTimeTranslation} />
      <ToggleButtonWithTooltip value="ANNUAL" text={texts.yearlyTranslation} />
      <ToggleButtonWithTooltip value="MONTHLY" text={texts.monthlyTranslation} />
      <ToggleButtonWithTooltip value="WEEKLY" text={texts.weeklyTranslation} />
    </ToggleButtonGroup>
  )
}
